import 'css-chunksrc/client/scenes/workloads/calendar/dailyMonths/styles.scss';export default {
  "months": "_months_5rxe1_1",
  "month": "_month_5rxe1_1"
};